export default __webpack_public_path__ + "static/features-phone-tutoring-0435f432b9525f31928a08a090138b76.png";